import request from '@/router/axios'
// 列表查询
export function searchList (current, size, params, url, method = 'get') {
  return request({
    url: url,
    method: method,
    params: {
      ...params,
      current,
      size
    }
  })
}

// get方法公用
export function getRequest (url, params = {}) {
  return request({
    url,
    method: 'get',
    params: {
      ...params
    }
  })
}

// Post 方法公用
export function postRequest (url, params = {}) {
  return request({
    url,
    method: 'post',
    data: params
  })
}

// @RequestParam 单字段
export function postRequestParam (url, key, value) {
  return request({
    url,
    method: 'post',
    params: {
      [key]: value
    }
  })
}

export function remove (url, ids) {
  return request({
    url,
    method: 'post',
    params: {
      ids
    }
  })
}



